// Mailing Black-List

export const mailDomainsBlacklist = new RegExp(`^(?![a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(gmail\.com|yahoo\.com|hotmail\.com|aol\.com|icloud\.com|comcast\.net|msn\.com|rocketmail\.com|sbcglobal\.net|verizon\.net|outlook\.com|cox\.net|earthlink\.net|test\.com)$)`);